<h1>{{ 'PRIVACY_POLICY.TITLE' | translate }}</h1>
